import React, { useEffect, useState } from 'react';
import { Alert, Avatar, Form, Input, Modal, Space, Tag, message } from 'antd';
import { CheckOutlined, CloseOutlined, UserOutlined } from '@ant-design/icons';
import { workflowApi } from '../../utils/api';

const { TextArea } = Input;

const MODULE_LABELS = {
  leave: 'مرخصی',
  overtime: 'اضافه‌کاری',
  regularization: 'اصلاح تردد',
  mission: 'مأموریت',
  expense: 'درخواست مالی',
  remote: 'دورکاری',
};

/**
 * مودال اقدام سریع تأیید / رد روی یک workflow instance
 */
const WorkflowActionModal = ({
  open,
  mode = 'approve', // approve | reject
  instanceId,
  summaryTitle = '',
  requester = null,
  moduleType = null,
  stepName = null,
  onClose,
  onSuccess,
}) => {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);
  const isReject = mode === 'reject';

  useEffect(() => {
    if (!open) return;
    form.setFieldsValue({ comment: '' });
  }, [open, form, mode]);

  const handleOk = async () => {
    if (instanceId == null) {
      message.error('شناسه فرآیند مشخص نیست');
      return;
    }
    try {
      const values = await form.validateFields();
      const comment = (values.comment || '').trim();
      if (isReject && !comment) {
        message.error('علت رد الزامی است');
        return;
      }
      setSaving(true);
      if (isReject) {
        await workflowApi.reject(instanceId, { comment });
        message.success('درخواست با موفقیت رد شد');
      } else {
        await workflowApi.approve(instanceId, { comment: comment || undefined });
        message.success('مرحله با موفقیت تأیید شد');
      }
      onSuccess?.();
      onClose?.();
    } catch (error) {
      if (error?.errorFields) return;
      message.error(error?.message || 'خطا در ثبت اقدام');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={
        <span style={{ fontFamily: 'CustomFont' }}>
          {isReject ? 'رد درخواست' : 'تأیید مرحله جاری'}
        </span>
      }
      okText={isReject ? 'رد درخواست' : 'تأیید درخواست'}
      cancelText="انصراف"
      okButtonProps={{
        danger: isReject,
        icon: isReject ? <CloseOutlined /> : <CheckOutlined />,
        className: isReject ? undefined : 'bg-emerald-600 hover:bg-emerald-700 border-emerald-600',
      }}
      onOk={handleOk}
      confirmLoading={saving}
      destroyOnClose
      width={480}
    >
      <div className="space-y-3" style={{ fontFamily: 'CustomFont' }}>
        <Alert
          type={isReject ? 'error' : 'info'}
          showIcon
          className="custom-font text-[12px]"
          message={
            isReject
              ? 'با رد این مرحله، درخواست رد می‌شود.'
              : 'با تأیید، درخواست به مرحله بعد می‌رود.'
          }
        />

        <div className="rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/40 p-3">
          <Space align="start" size={12}>
            <Avatar src={requester?.image} icon={<UserOutlined />} />
            <div>
              <div className="font-semibold text-slate-800 dark:text-slate-100">
                {summaryTitle || 'مورد در انتظار تأیید'}
              </div>
              <div className="text-xs text-slate-500 mt-0.5">
                {requester?.name || '—'}
                {moduleType ? (
                  <Tag className="custom-font m-0 mr-2 text-[10px]" color="blue">
                    {MODULE_LABELS[moduleType] || moduleType}
                  </Tag>
                ) : null}
              </div>
              {stepName ? (
                <div className="text-xs text-amber-700 dark:text-amber-300 mt-1">
                  مرحله جاری: {stepName}
                </div>
              ) : null}
            </div>
          </Space>
        </div>

        <Form form={form} layout="vertical">
          <Form.Item
            name="comment"
            label={isReject ? 'علت رد' : 'یادداشت'}
            rules={
              isReject
                ? [{ required: true, message: 'علت رد الزامی است' }]
                : []
            }
          >
            <TextArea
              rows={3}
              placeholder={
                isReject
                  ? 'علت رد را بنویسید'
                  : 'در صورت نیاز یادداشت بنویسید'
              }
              style={{ fontFamily: 'CustomFont' }}
            />
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default WorkflowActionModal;
